import React from 'react'

export default class PostActions extends React.Component {
  constructor() {
    super()
    this.state = {
      liked: false
    }
  }
  onLikePost() {
    this.setState({liked:true})
    this.props.onLikePost(this.props.post)
  }
  render() {
    let post = this.props.post
    if (post.status === 'publish' && typeof post.liveblog_likes === 'number') {
      return <div className="actions">
        <div className="likes-container">
          <span className="likes-counter">
            {post.liveblog_likes ? post.liveblog_likes : ''}
          </span>
          <button
            className="action-like"
            aria-label="like"
            disabled={this.state.liked}
            onClick={() => this.onLikePost()}
            >{this.state.liked ? "♥" : "♡"}</button>
        </div>
      </div>
    } else if (this.props.user && this.props.user.capabilities.publish_posts) {
      return <div className="actions">
        <button
          className="secondary"
          onClick={() => this.props.onRejectPost(post)}
        >Discard</button>
        <button
          className="primary"
          onClick={() => this.props.onApprovePost(post)}>Publish</button>
      </div>
    } else {
      return null
    }
  }
}

PostActions.propTypes = {
  onRejectPost: React.PropTypes.func.isRequired,
  onApprovePost: React.PropTypes.func.isRequired,
  user: React.PropTypes.object
}



/** WEBPACK FOOTER **
 ** ./src/PostActions.js
 **/